import { Flex, FlexItem, Popover, TextInput } from '@patternfly/react-core'
import { OutlinedTimesCircleIcon } from '@patternfly/react-icons'
import * as React from 'react'
import { useCallback, useState } from 'react'

import { displayLabelIfExists } from '@app/domain/instrument/instrument.helpers'
import type {
  IProgramInteraction,
  IProgramInteractionId} from '@app/domain/program/program.interface';
import {
  ProgramInteractionTypeId,
  editInteractionInstrumentsModalTittle,
} from '@app/domain/program/program.interface'
import { InfoPopoverContent } from '@app/utils/info-popover'
import { SmallButton } from '@app/utils/styles/small-button'

import { warningPopoverContent } from './messages'

interface AdHocInteractionProps {
  programInteraction: IProgramInteraction
  onDeleteInteraction: (programIteractionId: IProgramInteractionId) => void
  onEditInteraction: (
    modalTittle: string,
    programInteractionTypeId: ProgramInteractionTypeId,
    programInteraction?: IProgramInteraction,
  ) => void
  onEditInteractionLabel: (interactionId: string, label: string) => void
}

export const AdHocInteraction = ({
  onDeleteInteraction,
  onEditInteraction,
  onEditInteractionLabel,
  programInteraction,
}: AdHocInteractionProps) => {
  const [label, setLabel] = useState<string>(programInteraction.label)
  const [isPopoverVisible, setPopoverVisible] = useState(false)

  const handleDeleteInteraction = useCallback(() => {
    onDeleteInteraction(programInteraction.id)
  }, [onDeleteInteraction, programInteraction])

  const handleEditInteraction = useCallback(() => {
    onEditInteraction(
      editInteractionInstrumentsModalTittle,
      ProgramInteractionTypeId.AdHocInteraction,
      programInteraction,
    )
  }, [onEditInteraction, programInteraction])

  const handleLabelBlur = useCallback(() => {
    onEditInteractionLabel(programInteraction.id, label)
  }, [label, onEditInteractionLabel, programInteraction])

  const showPopover = useCallback(() => setPopoverVisible(true), [])
  const hidePopover = useCallback(() => setPopoverVisible(false), [])

  if (programInteraction.instruments.length > 0) {
    return (
      <>
        <Flex className="interaction-label-container">
          <FlexItem>
            <Popover
              aria-label="Delete Interaction Confirmation"
              isVisible={isPopoverVisible}
              shouldClose={hidePopover}
              bodyContent={
                <InfoPopoverContent
                  title="Danger"
                  body={warningPopoverContent}
                  isDanger={true}
                  onCancel={hidePopover}
                  onConfirm={handleDeleteInteraction}
                />
              }
            >
              <OutlinedTimesCircleIcon
                onClick={showPopover}
                className="link-image"
              />
            </Popover>
          </FlexItem>
          <FlexItem>
            <TextInput
              value={label ?? ''}
              isRequired
              type="text"
              id="label"
              name="label"
              onChange={setLabel}
              onBlur={handleLabelBlur}
              placeholder="Label"
            />
          </FlexItem>
        </Flex>
        <Flex>
          <FlexItem className="spacer" />
          <FlexItem className="label">Instruments:</FlexItem>
          <FlexItem>
            <SmallButton variant="secondary" onClick={handleEditInteraction}>
              Edit
            </SmallButton>
          </FlexItem>
          <FlexItem>
            {programInteraction.instruments
              ?.map(displayLabelIfExists)
              .join(', ')
              .toString()}
          </FlexItem>
        </Flex>
      </>
    )
  } else {
    return (
      <Flex>
        <FlexItem className="spacer" />
        <FlexItem className="label">Instruments:</FlexItem>
        <FlexItem />
        <FlexItem>
          <SmallButton variant="secondary" onClick={handleEditInteraction}>
            Edit
          </SmallButton>
        </FlexItem>
      </Flex>
    )
  }
}
